// affect chat layout
import './Chat.css';

const nctFormatter = (nct) => {
  const parts = nct.split('-', 1);
  return parts[0];
};

export const formatTextToUseNewLineBeforeNumbers = (text) => {
  try {
    return text.replace('**', '').replace(/\n/g, '<br />');
  } catch (error) {
    return text;
  }
};

export const formmatedTrials = (trials) => {
  return trials
    .sort((a, b) => {
      if (a.score !== b.score) {
        return b.score - a.score;
      }
    })
    .map(a => ({
      nct_number: nctFormatter(a.nct_number),
      brief_summary: a.brief_summary,
      main_objectives: a.main_objectives,
      treatment_administration_type: a.treatment_administration_type,
      enrollment: a.enrollment,
      phases: a.phases,
      study_type: a.study_type,
      sponsorName: a.sponsorName,
      groups: a.groups,
      nearestDistance: a.nearest_facility_distance,
      isSponsored: a.isSponsored,
      closest_facility: a.closest_facility,
    }));
};
